// oxlint-disable-next-line no-restricted-imports -- query client for admin + platform islands until they move to colada
import { QueryClient } from "@tanstack/vue-query";

import { singleton } from "@solvari/utils";

const useQueryClient = singleton(() => {
  return new QueryClient();
});

export { useQueryClient };
